export default __webpack_public_path__ + "static/media/osu-web-header-horiz.fa91f285.png";